import "core-js/stable"
import "regenerator-runtime/runtime"

// common style
import '@stylesheets/application'

// base
import Vue from 'vue/dist/vue.esm'
import router from '@/routes.js'
import store from '@/store/store'
import i18n from '@/i18n'

import '@/common-functions'
import '@/validations/vee'

// directives
import '@/directives/click-outside'
import '@/directives/m-android-focus'

import device from 'current-device'
Vue.prototype.$device = device

import VueCarousel from 'vue-carousel'
Vue.use(VueCarousel)

import BackToTop from 'vue-backtotop'
Vue.use(BackToTop)

import underscore from 'vue-underscore'
Vue.use(underscore)

import axios from 'axios'
axios.defaults.headers.common = {
  'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
}

import InfoTip from "@/components/global/InfoTip"
Vue.component('InfoTip', InfoTip)

import ServerErrors from '@/components/global/ServerErrors'
Vue.component('ServerErrors', ServerErrors)

// init app
const event = (typeof Turbolinks == 'object' && Turbolinks.supported) ? 'turbolinks:load' : 'DOMContentLoaded'

document.addEventListener(event, () => {
  new Vue({
    el: '[data-behavior="vue"]',
    router: router,
    store: store,
    i18n: i18n
  })
})
